module.exports = __webpack_public_path__ + "static/media/sitejabber-mark-5.861c361b.svg";